// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__5nAlA","header":"MessagesList_header__2a6jq","chat":"MessagesList_chat__14oiT"};